<template>
  <div>
    <add-to-stream></add-to-stream>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import AddToStream from './AddToStream'

  export default {
    name: 'course-search',
    props: ['streamUuid', 'currentSemester', 'currentYear'],
    components: {
      AddToStream
    },
    data: () => {
      return {

      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'loginToGoogleCalendar',
        'syncWithGoogleCalendar',
        'setGoogleCalendarSyncStatusMessage'
      ]),
      loadProps () {
        let streamUuid = (this.streamUuid) ? this.streamUuid : localStorage.getItem('streamUuid')
        let currentSemester = (this.currentSemester) ? this.currentSemester : localStorage.getItem('currentSemester')
        let currentYear = (this.currentYear) ? this.currentYear : localStorage.getItem('currentYear')
        let googleOAuthToken = this.$route.query.token

        return {streamUuid: streamUuid, currentSemester: currentSemester, currentYear: currentYear, googleOAuthToken: googleOAuthToken}
      },
      loadData () {
        console.log('loadData called')
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      onShown () {
        console.log('onShown called')
      }
    },
    computed: {
      ...mapState({
        'courses': state => state.semester.courses,
        'iCalFile': state => state.semester.iCalFile
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/search/components/CourseSearch.vue